import React from 'react';
import { I18nextProvider } from 'react-i18next';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import i18n from '../../i18n/config';
import { ErrorBoundary } from '../router/ErrorBoundary';

interface Props {
  children: React.ReactNode;
}

export const AppProviders: React.FC<Props> = ({ children }) => {
  return (
    <I18nextProvider i18n={i18n}>
      <ErrorBoundary>
        {children}
        <ReactQueryDevtools initialIsOpen={false} />
      </ErrorBoundary>
    </I18nextProvider>
  );
};

